import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "suv"
const SuvIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path
            fillRule="evenodd"
            d="M10.632 7.313C12.365 7.313 14.066 7.783 15.552 8.676L17.089 9.596 20.415 10.365C21.525 10.622 22.312 11.61 22.312 12.75V15.05C22.312 15.516 21.97 15.912 21.507 15.978L19.447 16.27C19.205 17.47 18.147 18.375 16.875 18.375 15.755 18.375 14.8 17.674 14.423 16.688H8.827C8.449 17.674 7.494 18.375 6.375 18.375 5.255 18.375 4.3 17.674 3.923 16.688H3.061C2.13 16.688 1.466 15.813 1.687 14.93V10.292L3.283 8.429C3.016 8.385 2.813 8.154 2.813 7.875 2.812 7.565 3.063 7.313 3.374 7.313zM6.375 14.625C5.754 14.625 5.25 15.129 5.25 15.75S5.754 16.875 6.375 16.875 7.5 16.371 7.5 15.75 6.996 14.625 6.375 14.625M16.875 14.625C16.253 14.625 15.75 15.129 15.75 15.75S16.253 16.875 16.875 16.875C17.496 16.875 18 16.371 18 15.75S17.496 14.625 16.875 14.625M2.812 10.708V11.438H3.375C3.685 11.438 3.937 11.689 3.937 12 3.937 12.31 3.685 12.562 3.375 12.563H2.812V15.092L2.784 15.178C2.72 15.368 2.86 15.562 3.06 15.562H3.758C3.854 14.2 4.988 13.126 6.375 13.126 7.76 13.125 8.896 14.2 8.992 15.563H14.258C14.354 14.2 15.488 13.125 16.875 13.125 18.114 13.125 19.152 13.984 19.427 15.138L21.187 14.888V13.312H19.875C19.565 13.313 19.312 13.06 19.312 12.75S19.564 12.188 19.875 12.188H21.06C20.893 11.829 20.567 11.555 20.161 11.46L16.812 10.687H5.952C5.202 10.688 4.755 9.854 5.17 9.23L5.699 8.437H4.759zM6.301 9.562H8.969L8.594 8.439H7.051zM10.156 9.563H14.839C13.559 8.828 12.109 8.439 10.632 8.439H9.78z"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default SuvIcon
